<template>
  <div class="consultation-step1">
    <div class="consultation__wrapper">
      <div class="consultation__col consultation__col_pull-bottom-tablet">
        <p class="consultation-step1__info-text">
          {{ title }}
        </p>
        <form
          class="consultation-step1__form"
        >
          <BaseSelect
            v-model="formData.model"
            :items="fields.model.items"
            :emitOnCreate="false"
            class="consultation-step1__form-filed"
            :label="fields.model.label"
            :placeholder="fields.model.placeholder"
            :required="fields.model.required"
            :errorMsg="errorMessages.model"
            @input="getEngine"
          />
          <div
            v-if="engineItems && engineItems.length && loadEngineItems"
            class="consultation-step1__engine"
          >
            <Tabs
              :key="formData.model"
              v-model="formData.engine"
              :items="engineItems"
              :label="fields.engine.label"
              :errorMsg="errorMessages.engine"
              :defaultEngine="defaultFields && defaultFields.engine"
              @input="setTextEngine"
            />
          </div>
        </form>
        <BaseButton
          v-if="isGoToNextStep"
          class="consultation-step1__button hidden-desktop"
          @click="goToNextStep"
        >
          {{ submit.label }}
        </BaseButton>
      </div>
      <div class="consultation__col">
        <img
          v-if="imageUrl"
          :src="testUrl(imageUrl)"
          class="consultation-step1__img"
          alt=""
        >
        <BaseButton
          v-if="isGoToNextStep"
          class="consultation-step1__button hidden-tablet"
          @click="goToNextStep"
        >
          {{ submit.label }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import get from 'lodash/get'

  import Tabs from '../Tabs'
  import crud from '../crud'

  export default {
    name: 'ConsultationStep1',

    components: {
      Tabs
    },

    mixins: [crud],

    props: {
      defaultFields: [Object, Boolean],
      title: String,
      fields: Object,
      modelImageUrl: String,
      submit: Object,
      resetDefault: Function
    },

    data () {
      return {
        formData: {
          model: '',
          engine: ''
        },
        errorMessages: {
          model: '',
          engine: ''
        },
        engineItems: '',
        loadEngineItems: true,
        imageUrl: '',

        isSetModel: false,

        step1: {
          modelText: '',
          engineText: ''
        }
      }
    },

    computed: {
      ...mapState(['currentLang']),

      isGoToNextStep () {
        return !!this.formData.model && !!this.formData.engine
      }
    },

    watch: {
      'formData.engine' () {
        if (this.isSetModel) {
          this.resetDefault()
        }
        this.isSetModel = true
      },
      'formData.model' () {
        this.getImage()
      },
      'defaultFields.model': {
        handler () {
          if (this.defaultFields && this.defaultFields.model && this.defaultFields.model.value) {
            this.formData.model = this.defaultFields.model.value
            this.getEngine(this.defaultFields.model.value, this.defaultFields.model)
            if (this.defaultFields.engine) {
              this.formData.engine = this.defaultFields.engine
            }
          }
        },
        immediate: true
      }
    },

    created () {
      // model link params
      const id = _.get(this.fields, 'model.value', '') || ''
      if (this.$route.query.model && (!!id || id === 0)) {
        this.$set(this.formData, 'model', id)
        this.getEngine(id, _.find(_.get(this.fields, 'model.items'), item => item.value === id))
      } else {
        this.getImage(_.get(this.fields, 'model.items[0].value', 1))
      }
    },

    mounted () {
      if (this.$route.query.dealer && this.$route.query.city) {
        this.getDealer()
      }
    },

    methods: {
      async getDealer () {
        const { data } = await window.axios.get(`/online/dealer-list?city=${this.$route.query.city}&dealer=${this.$route.query.dealer}`)
        this.$store.commit('consultation/SET_SHOWROOM_PERIOD', data.items[0].showroomPeriod)
        this.$store.commit('consultation/SET_STEP2', {
          ...data.items[0],
          dealersText: data.items[0].text,
          dealerId: data.items[0].dealerId || '',
          dealerCity: data.items[0].city,
          dealerZipCode: data.items[0].zipcode || ''
        })
      },
      pushDataToDataLayer (params = {
        events: {},
        forms: {
          name: 'lead-book-dealer-appointment',
          step: 'select-model',
          conversion: '0'
        },
        products: [{}]
      }, pushDataLayer = false, dataForDataLayer = { 'event': 'formevent' }) {
        const event = params.events || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-dealer-appointment',
          language: _.get(this, 'currentLang', '')
        }

        const form = params.forms || {}

        const product = params.products || [{}]

        window.tngaDataLayer = { event, page, form, product }
        window.dataLayer = window.dataLayer || []
        if (pushDataLayer) {
          window.dataLayer.push(dataForDataLayer)
        }
      },

      checkNull (data) {
        if (data) return data
        return ''
      },

      setTextModel (e, obj) {
        const modelCorrespondenceTable = [
          { text: 'Corolla', textNew: 'Corolla sedan' }
        ]

        if (modelCorrespondenceTable.find(item => item.text === _.get(obj, 'text', ''))) {
          this.step1.modelText = this.checkNull(_.get(modelCorrespondenceTable.find(item => item.text === _.get(obj, 'text', '')), 'textNew', ''))
        } else this.step1.modelText = _.get(obj, 'text', '')
      },

      setIdModel (e, obj) {
        const modelCorrespondenceTable = [
          { text: 'Corolla sedan', id: 'corolla' },
          { text: 'Corolla Hatchback', id: 'corolla-hb' },
          { text: 'Corolla Touring Sports', id: 'corolla-ts' }
        ]

        if (modelCorrespondenceTable.find(item => item.text === this.step1.modelText)) {
          this.step1.modelId = this.checkNull(_.get(modelCorrespondenceTable.find(item => item.text === this.step1.modelText), 'id', ''))
        } else this.step1.modelId = _.get(obj, 'toyotaModelId', '')
      },

      setTextEngine (e, obj) {
        this.step1.engineText = _.get(obj, 'label', '')
      },

      async goToNextStep () {
        try {
          const sendData = {
            model: this.formData.model,
            engine: this.formData.engine
          }
          const { data } = await window.axios.post(this.submit.url, sendData)

          this.pushDataToDataLayer({
            events: {
              name: 'formevent',
              componentName: 'book-dealer-appointment',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'model-selected'
            },
            forms: {
              name: 'lead-book-dealer-appointment',
              step: 'model-selected',
              conversion: '0'
            },
            products: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.step1.modelId,
                productName: this.step1.modelText,
                tmeModelId: this.step1.modelId,
                modelName: this.step1.modelText
              }
            }]
          })

          this.$store.commit('consultation/SET_STEP1', {
            ...sendData,
            modelText: this.step1.modelText,
            modelId: this.step1.modelId,
            engineText: this.step1.engineText
          })
          this.$emit('nextStep', data)
        } catch (err) {
          Object.keys(get(err, 'response.data', {})).forEach((key) => {
            this.errorMessages[key] = get(err, 'response.data', {})[key]
          })
          console.log(this.errorMessages)
          console.log(err)
        }
      },

      async getImage (model) {
        try {
          const { data } = await window.axios.post(this.modelImageUrl, {
            model: model || this.formData.model
          })
          this.imageUrl = data
        } catch (e) {
          console.log(e)
        }
      },

      async getEngine (id, item) {
        this.setTextModel(id, item)
        this.setIdModel(id, item)

        try {
          this.loadEngineItems = false
          const { data } = await window.axios.get(`${this.fields.engine.url}?model_id=${id}`)
          this.engineItems = data
          this.loadEngineItems = true

          this.pushDataToDataLayer({
            events: {
              name: 'formevent',
              componentName: 'book-dealer-appointment',
              componentGroup: 'forms',
              action: 'form-step',
              label: 'model-selected'
            },
            forms: {
              name: 'lead-book-dealer-appointment',
              step: 'model-selected',
              conversion: '0'
            },
            products: [{
              category: 'cars',
              subCategory: 'new-cars',
              productInfo: {
                productId: this.step1.modelId,
                productName: this.step1.modelText,
                tmeModelId: this.step1.modelId,
                modelName: this.step1.modelText
              }
            }]
          }, true)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>
<style lang="scss">
  .consultation-step1 {
    &__info-text {
      margin-bottom: 40px;
      font-size: 22px;
      line-height: 33px;

      @media (max-width: 991px) {
        font-size: 17px;
        line-height: 30px;
      }
    }

    &__engine {
      //margin-bottom: 10px;
    }

    &__img {
      width: 100%;
      max-height: 400px;
      object-fit: contain;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        width: auto;
        max-width: 100%;
      }

      @media (max-width: 991px) {
        display: block;
        width: auto;
        max-width: 100%;
        margin: 0 auto;
      }
    }

    &__button {
      display: block;
      margin-top: 20px;
      margin-left: auto;
    }

    .hidden-desktop {
      @media (min-width: 992px) {
        display: none;
      }
    }

    .hidden-tablet {
      @media (max-width: 991px) {
        display: none;
      }
    }
  }
</style>
